import { Component, Input, Output, EventEmitter } from "@angular/core";
import { AccountService } from "../../../account/services/account.service";
import { config } from "@config";
import { Term } from "@models/term";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Validateable } from "@models/interfaces";
import { Account } from "@models";
import { UserService } from "@main-services/user.service";

@Component({
	selector: "legal-settings",
	templateUrl: "./legal-settings.component.html",
	standalone: false
})
export class LegalSettingsComponent {
	@Input()
	public model: Account;

	@Input()
	public disabled: boolean;

	@Output()
	public modelChange: EventEmitter<Term[]> = new EventEmitter<Term[]>();

	public showTerms: boolean;
	public policyLabel: string;

	private signupTerms: Term[];

	public groupModel: LegalGroupSwitch = new LegalGroupSwitch();

	public constructor(
		private accountService: AccountService,
		private userService: UserService,
		private apicallService: ApicallService
	) {
		this.policyLabel = "register_privacy_policy";

		if (!this.userService.user.getLoggedIn()) {
			this.apicallService.get("users/pending_terms", new ApicallOption(Term)).subscribe((a) => {
				this.signupTerms = a;
				this.updateInitButtonsState();
			});
		} else {
			this.accountService.update();
			this.updateInitButtonsState();
		}
	}

	private updateInitButtonsState(): void {
		this.groupModel.signed_terms_conditions = this.hasAlreadySigned(this.termsOnly);
		this.groupModel.signed_privacy_policies = this.hasAlreadySigned(this.policiesOnly);
	}

	public get baseUrl(): string {
		return config.baseUrl;
	}

	public onChange(event: Event): void {
		this.updateGroupValues();
		this.modelChange.emit(this.terms);
	}

	public get terms(): Term[] {
		if (this.userService.user.getLoggedIn()) {
			return this.accountService.account.getTerms();
		}

		return this.signupTerms;
	}

	public get termsOnly(): Term[] {
		return this.getFiltertedTerms("terms");
	}

	public get policiesOnly(): Term[] {
		return this.getFiltertedTerms("policy");
	}

	private getFiltertedTerms(type: string): Term[] {
		if (this.terms) {
			return this.terms.filter((t) => t.getType().includes(type) && !t.originalHasSigned());
		}
		return [];
	}

	public get nonTermsOrPolicy(): Term[] {
		if (this.terms) {
			return this.terms.filter(
				(t) => !t.getType().includes("terms") && !t.getType().includes("policy") && !t.originalHasSigned()
			);
		}
		return [];
	}

	private updateGroupValues(): void {
		// Update terms
		this.termsOnly.forEach((item) => {
			item.setSigned(this.groupModel.signed_terms_conditions);
		});
		// Update policies
		this.policiesOnly.forEach((item) => {
			item.setSigned(this.groupModel.signed_privacy_policies);
		});
	}

	// Check per groups (eg: all terms / all policies)
	private hasAlreadySigned(terms: Term[]): boolean {
		return terms.every((item) => item.hasSigned());
	}
}

class LegalGroupSwitch extends Validateable {
	public signed_terms_conditions: boolean = false;
	public signed_privacy_policies: boolean = false;
}
